import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/backgroundJobs'
import { Link } from 'react-router-dom'
import Icon from '@/components/Icon'
import Resx from '@/components/Resx'

class GoToBackgroundJobsLink extends React.Component {
  handleClick = () => {
    this.props.loadBackgroundJobs(0)
    if (typeof this.props.onClick === 'function') { this.props.onClick() }
  }
  render () {
    const { title, showIcon, className } = this.props
    return (
      <Link to='/background-jobs' className={className} onClick={this.handleClick}>{showIcon && <Icon name='bx-history' /> } <span><Resx name={title || 'Common.BackgroundJobs'} /></span></Link>
    )
  }
}

const mapDispatchToProps = {
  loadBackgroundJobs: actionCreators.loadBackgroundJobs
}
export default connect(null, mapDispatchToProps)(GoToBackgroundJobsLink)



// WEBPACK FOOTER //
// ./src/components/backgroundJobs/goToBackgroundJobsLink.js